import { AtomicBlockUtils } from 'draft-js';

const insertTeXBlock = async (editorState, type) => {
  const contentState = editorState.getCurrentContent();
  let texcontent;

  if (type === 'price') {
    texcontent = -42;
  } else if (type === 'miles') {
    texcontent = -43;
  } else if (type === 'form') {
    texcontent = -44;
  } else {
    texcontent = -43; // default to miles
  }

  const contentStateWithEntity = contentState.createEntity('TOKEN', 'IMMUTABLE', {
    texcontent: texcontent,
  });
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

  return AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
};

export default insertTeXBlock;
